import React from "react";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import "./LeadershipSubPage.css";

const BoardOfDirectors = () => (
  <div className="leadership-sub-page" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
    <PageBanner
      title="Board of Directors"
      backLabel="Back to Leadership"
      backPath="/leadership"
    />

    <ScrollReveal variant="fadeUp">
    <section className="leadership-sub-content">
        <div className="leadership-sub-inner">
          <h2>Strategic Oversight & Governance</h2>
          <p>
            The Board of Directors of Pawansut Holdings Limited provides strategic direction, oversight, and governance. Board members bring diverse experience from finance, regulation, and corporate leadership to ensure the company operates with integrity and in the best interest of shareholders and stakeholders.
          </p>
          <p>
            The Board is responsible for approving major strategies, risk frameworks, financial reporting, and key appointments. It meets regularly to review performance, compliance, and long-term objectives.
          </p>
          <h3>Key Responsibilities</h3>
          <ul>
            <li>Setting strategic direction and approving business plans</li>
            <li>Overseeing risk management and internal controls</li>
            <li>Ensuring compliance with regulatory and governance standards</li>
            <li>Reviewing and approving significant transactions</li>
            <li>Monitoring executive performance and succession planning</li>
          </ul>
        </div>
    </section>
    </ScrollReveal>
  </div>
);

export default BoardOfDirectors;
